import {useTwoFactor} from "_api/hooks/two-factor";
import styled from "styled-components";

const Container = styled.div`
    max-width: 300px;
`;
export const QrCode = () => {
    const {twoFactor: {svg}} = useTwoFactor();

    return (
        <Container>
            <div dangerouslySetInnerHTML={{__html: svg}}/>
        </Container>
    );
}
